<template>
  <div class="page-container" style="min-height: 800px;">
    <Loading ref="loading" />
    <h2 class="center-items" v-if="invoices.length === 0">No invoices</h2>

    <div class="page-title-container">
      <h1 class="title-text">Your invoices</h1>
    </div>

    <div class="dashboard-container" style="padding: 1rem 1.5rem;">
      <div v-for="(invoice, i) in invoices" :key="i">
        <p>Order Id: {{ invoice.order_id }}</p>
        <p>Plan Name: {{ invoice.plan_name }}</p>

        <div style="margin-bottom: 0.2rem;">
          <a :href="invoice.update_url" style="font-size: 0.8rem; text-decoration: underline; cursor: pointer;">Update payment method</a>
        </div>

        <br />

        <a :href="invoice.receipt_url" style="font-size: 0.8rem; text-decoration: underline; cursor: pointer;">Manage Invoice</a>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "@/firebase";
import Loading from "@/components/Loading";

export default {
  components: {
    Loading,
  },

  data() {
    return {
      invoices: [],
    };
  },

  mounted() {
    this.$refs.loading.open();
  },

  created() {
    window.scrollTo(0, 0);
    firebase.functions
      .httpsCallable("getSubscriptionState")()
      .then((r) => {
        for (const userPlan of r.data.userPlans) {
          this.invoices.push(userPlan);
        }
        this.$refs.loading.close();
      })
      .catch((e) => console.error(e));
  },
};
</script>

<style></style>
